import React from 'react'
import PropTypes from 'prop-types'
import {
  Card,
  Text,
  Flex,
  Box,
  Button,
  Image,
  getPaletteColor,
} from 'pcln-design-system'
import { ChevronRight } from 'pcln-icons'
import styled from 'styled-components'
import Cookies from 'cookies-js'
import FireRudderstackImpressionEvent from './FireRudderstackImpressionEvent'

const ImageContainer = styled(Box)`
  height: auto;
  max-height: 145px;
`

const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: center;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadii.xl};
  border-top-left-radius: ${({ theme }) => theme.borderRadii.xl};
  height: 100%;
  width: 100%;
`

const FlexBannerContainer = styled(Flex)`
  cursor: pointer;
`
const StyledCard = styled(Card)`
  border: 1px solid ${getPaletteColor('border.base')};
`

export function HotelCrossSellComponent({
  imgObj,
  imgWidth,
  buttonLayout,
  bannerMx,
  handleItemClick,
  headerFontSize,
  headerColour,
  headingCopy,
  subheadingCopy,
  btnCopy,
  isButtonStyle,
  isDetails,
  isVariant,
}) {
  const isWindowReady = typeof window !== 'undefined'
  const isMobile = isWindowReady && window?.PCLN_BOOTSTRAP_DATA?.isMobile
  const imgUrl = isMobile ? imgObj?.imgSm : imgObj?.imgLg
  const dataCguid = Cookies?.get('SITESERVER')
  const marginBottomTexts = isVariant ? 1 : 0
  const rudderstack = {
    'data-rudder-event': true,
    'data-sub-type': 'cross_sell',
    'data-cguid': dataCguid?.slice(3),
    'data-child-product': 'STAY',
    'data-parent-product': 'FLY',
    'data-source': isDetails ? 'flights details' : 'flights listing',
    'data-category': 'click',
  }

  return (
    <FlexBannerContainer
      flexDirection={'column'}
      onClick={handleItemClick}
      id={'package-cross-sell'}
      mx={bannerMx}
      mb={bannerMx === 3 && 3}
      //rudderstack attributes
      {...rudderstack}
    >
      <FireRudderstackImpressionEvent
        rudderstack={{ ...rudderstack, 'data-category': 'impression' }}
      >
        <StyledCard
          boxShadowSize='md'
          borderWidth={0}
          borderRadius='xl'
          color='background.light'
        >
          <Flex my='auto'>
            <ImageContainer width={imgWidth}>
              <StyledImage alt={imgObj?.alt} src={imgUrl} />
            </ImageContainer>
            <Flex
              p={3}
              width={1}
              alignItems={
                buttonLayout === 'row'
                  ? ['start', null, 'center', 'center', 'center']
                  : 'start'
              }
              justifyContent='space-between'
              flexDirection={
                buttonLayout === 'row'
                  ? ['column', null, 'row', 'row', 'row']
                  : 'column'
              }
            >
              <Box mr={3}>
                <Text
                  bold
                  fontSize={headerFontSize}
                  color={headerColour}
                  mb={marginBottomTexts}
                >
                  {headingCopy}
                </Text>
                <Text fontSize={0} mb={marginBottomTexts}>
                  {subheadingCopy}
                </Text>
                {isVariant && (
                  <Button variation={'link'} size={'small'}>
                    <Flex>
                      {btnCopy}
                      <ChevronRight size={16} ml={1} />
                    </Flex>
                  </Button>
                )}
              </Box>
              {!isVariant && (
                <Button
                  variation={isButtonStyle ? 'fill' : 'link'}
                  size={'small'}
                  mt={buttonLayout === 'row' ? [2, 2, 0, 0, 0] : 2}
                >
                  {btnCopy}
                </Button>
              )}
            </Flex>
          </Flex>
        </StyledCard>
      </FireRudderstackImpressionEvent>
    </FlexBannerContainer>
  )
}

HotelCrossSellComponent.propTypes = {
  flyGaLogic: PropTypes.object.isRequired,
  imgObj: PropTypes.shape({
    img: PropTypes.string.isRequired,
    imgSm: PropTypes.string.isRequired,
    imgLg: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  imgWidth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  handleItemClick: PropTypes.func.isRequired,
  headerFontSize: PropTypes.number,
  headerColour: PropTypes.string,
  bannerMx: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  buttonLayout: PropTypes.oneOf(['row', 'column']),
  headingCopy: PropTypes.string,
  subheadingCopy: PropTypes.string,
  rudderstack: PropTypes.array,
  btnCopy: PropTypes.string,
  isButtonStyle: PropTypes.bool,
  isDetails: PropTypes.bool,
  isVariant: PropTypes.bool,
}

HotelCrossSellComponent.defaultProps = {
  buttonLayout: 'row',
  headerFontSize: 3,
  headerColour: 'primary.base',
  bannerMx: 3,
  headingCopy: 'Save an average of $240 on your trip!',
  subheadingCopy:
    'Add a Hotel stay with your Flight booking for extra savings.',
  btnCopy: 'Add a Hotel',
  isButtonStyle: true,
  isVariant: false,
}
